import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/ReportsIllustration.tsx
const ReportsIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "reports.svg",
		alt: t("illustration.imageAlt.reports")
	});
};

//#endregion
export { ReportsIllustration };